module.exports = __webpack_public_path__ + "img/SKLB-Numero Tel.f01514a4.png";